var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthcare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5714 0C17.5458 0 16.7143 0.831471 16.7143 1.85714V16.7143H1.85714C0.831471 16.7143 0 17.5458 0 18.5714V33.4286C0 34.4542 0.831471 35.2857 1.85714 35.2857H16.7143V50.1429C16.7143 51.1685 17.5458 52 18.5714 52H33.4286C34.4542 52 35.2857 51.1685 35.2857 50.1429V35.2857L50.1429 35.2857C50.6354 35.2857 51.1078 35.0901 51.4561 34.7418C51.8043 34.3935 52 33.9211 52 33.4286V18.5714C52 17.5458 51.1685 16.7143 50.1429 16.7143H35.2857V1.85714C35.2857 0.831471 34.4542 0 33.4286 0H18.5714Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcare);
export default __webpack_public_path__ + "static/media/healthcare.d83535f5cdeba350d6d0532d4516065f.svg";
export { ForwardRef as ReactComponent };